import { isDisabledValue } from "./formsviewer/uiHelpers/viewHelpers";

const $ = window.jQuery;

function makeItemsFilesAccessor(items) {
    const files = Array.prototype.slice.call(items)
        .filter((item) => item.kind === 'file')
        .map((item) => item.getAsFile());

    return {
        files,
        clear: items.clear.bind(items)
    };
}

function makeFilesFilesAccessor(dt) {
    var files = Array.prototype.slice.call(dt.files);

    return {
        files,
        clear: dt.clearData.bind(dt)
    };
}

function makeFilesAccessor(dt) {
    if (!dt) {
        return {
            files: [],
            clear: function () { }
        };
    }
    if (dt.items) {
        return makeItemsFilesAccessor(dt.items);
    }
    return makeFilesFilesAccessor(dt);
}

const isSupported = () =>
    typeof FileReader !== 'undefined';

const isDisabled = (el) =>
    isDisabledValue(el.getAttribute('disabled'));

function fileDropZone({ container, selector, onDragStart, onDragEnd, onDrop }) {
    $(container)
        .on('dragenter', selector, function (ev) {
            const { currentTarget } = ev;

            if (!isDisabled(currentTarget) && onDragStart) {
                onDragStart($(currentTarget));
            }
        })
        .on('dragleave', selector, function (ev) {
            const { currentTarget, relatedTarget } = ev;

            if (onDragEnd &&
                !$.contains(currentTarget, relatedTarget) &&
                currentTarget !== relatedTarget) {
                onDragEnd($(ev.currentTarget));
            }
        })
        .on('dragover', selector, function (ev) {
            ev.preventDefault();
        })
        .on('drop', selector, function (ev) {
            ev.preventDefault();

            const { currentTarget, originalEvent } = ev;

            if (isDisabled(currentTarget)) {
                return;
            }

            if (onDragEnd) {
                onDragEnd($(currentTarget));
            }
            if (onDrop) {
                onDrop({
                    target: $(currentTarget),
                    data: makeFilesAccessor(originalEvent.dataTransfer)
                });
            }
        });
}

fileDropZone.isSupported = isSupported;

export default fileDropZone;